(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["addi-widget"] && !Shopify.designMode) return;
  try {
    /* La tarjeta de Addi se pinta con `width: fit-content`, así que queda más
   angosta que el banner de Mercado Pago y que el botón de agregar al carrito.
   Esa regla vive dos shadow roots adentro (addi-product-widget →
   addi-product-banner): no la alcanzan ni el CSS de la página ni los atributos
   de configuración que expone Addi. Como los shadow roots son `open`, se les
   inyecta una hoja de estilos en cuanto termina de hidratarse.

   Hay que tocar los dos niveles. `addi-product-banner` es un elemento propio,
   o sea `display: inline` por defecto: su ancho lo marca el contenido, y un
   `width: 100%` puesto solo en la tarjeta de dentro se calcularía sobre ese
   ancho ya encogido. */
(function () {
  var config = document.querySelector('script[data-name="shopifyAddiWidget"]');
  if (!config) return;

  /* `!important` no es capricho: Addi aplica sus estilos con
     `adoptedStyleSheets`, que en la cascada van DESPUÉS de los `<style>` del
     propio shadow root. Sin él, sus reglas ganan por orden aunque la nuestra se
     inserte la última. */

  /* Nivel 1: el hueco donde Addi mete el banner. */
  var CSS_WIDGET = 'addi-product-banner{display:block!important;width:100%!important}';

  /* El color de borde se lee del mismo atributo que ya lleva el <script>, así
     que sigue saliendo del ajuste del tema y no hay dos sitios que tocar.
     Hace falta repetirlo aquí porque su regla estática
     `.addi-banner{border:1px solid #ebeced}` pisa a la que Addi genera con el
     atributo: el ajuste de color de su propio widget no llega a aplicarse. */
  var borde = config.getAttribute('widget-border-color');

  /* Nivel 2: el propio banner, su div anónimo intermedio y la tarjeta. */
  var CSS_BANNER = [
    ':host{display:block!important;width:100%!important}',
    ':host > div{width:100%!important}',
    '.addi-banner-wrapper,.addi-banner{width:100%!important;box-sizing:border-box}',
    borde ? '.addi-banner{border-color:' + borde + '!important}' : '',
  ].join('');

  var intentos = 0;

  function inyectar(raiz, css) {
    if (!raiz || raiz.querySelector('style[data-addi-ancho]')) return;
    var estilo = document.createElement('style');
    estilo.setAttribute('data-addi-ancho', '');
    estilo.textContent = css;
    raiz.appendChild(estilo);
  }

  function estirar() {
    var host = document.querySelector('addi-product-widget');
    if (!host || !host.shadowRoot) return false;
    var banner = host.shadowRoot.querySelector('addi-product-banner');
    if (!banner || !banner.shadowRoot) return false;
    inyectar(host.shadowRoot, CSS_WIDGET);
    inyectar(banner.shadowRoot, CSS_BANNER);
    return true;
  }

  /* Addi tarda lo suyo y a veces no llega nunca: se reintenta 20 segundos. */
  var reloj = setInterval(function () {
    if (estirar() || ++intentos > 40) clearInterval(reloj);
  }, 500);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-brand-slider"] && !Shopify.designMode) return;
  try {
    (function () {
  /* Delegado y con marca en el nodo: el AJAX de filtros repinta la columna
     entera, así que el slider se reconstruye y hay que re-inicializarlo. */
  function init(slider) {
    if (slider.dataset.ready) return;
    slider.dataset.ready = '1';

    var track = slider.querySelector('[data-brand-slider-track]');
    var prev  = slider.querySelector('[data-brand-slider-prev]');
    var next  = slider.querySelector('[data-brand-slider-next]');
    if (!track) return;

    function sync() {
      var desborda = track.scrollWidth > track.clientWidth + 2;
      slider.classList.toggle('brand-slider--overflow', desborda);
      if (!prev || !next) return;
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    }

    function paso(dir) {
      var pill = track.querySelector('.brand-pill');
      if (!pill) return;
      var gap = parseInt(getComputedStyle(track).gap, 10) || 8;
      /* Avanza casi una pantalla, dejando una píldora a la vista como ancla */
      var visibles = Math.max(1, Math.floor(track.clientWidth / (pill.offsetWidth + gap)) - 1);
      var salto = (pill.offsetWidth + gap) * visibles;
      var antes = track.scrollLeft;
      var destino = dir === 'next' ? antes + salto : antes - salto;
      destino = Math.max(0, Math.min(destino, track.scrollWidth - track.clientWidth));

      track.scrollTo({ left: destino, behavior: 'smooth' });
      /* Respaldo: hay contextos donde el navegador ignora el desplazamiento
         suave y la flecha se quedaría muerta. Si a los 120 ms no se movió, se
         asigna directo — se pierde la animación, no la función. */
      setTimeout(function () {
        if (track.scrollLeft === antes && destino !== antes) {
          track.scrollLeft = destino;
        }
        sync();
      }, 120);
    }

    if (prev) prev.addEventListener('click', function () { paso('prev'); });
    if (next) next.addEventListener('click', function () { paso('next'); });
    track.addEventListener('scroll', sync, { passive: true });

    sync();
    if (window.ResizeObserver) new ResizeObserver(sync).observe(track);
  }

  function initAll() {
    document.querySelectorAll('[data-brand-slider]').forEach(init);
  }

  initAll();
  document.addEventListener('shopify:section:load', initAll);
  /* Tras filtrar por AJAX el nodo es nuevo: se observa la columna de productos */
  var zona = document.getElementById('collection-products');
  if (zona && window.MutationObserver) {
    new MutationObserver(initAll).observe(zona, { childList: true, subtree: true });
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-menu"] && !Shopify.designMode) return;
  try {
    (function() {
  var checkbox = document.getElementById('mobile-menu-toggle');
  var menu = document.querySelector('[data-mobile-menu]');
  if (!checkbox || !menu) return;

  var panels = menu.querySelector('.mobile-menu__panels');
  if (!panels) return;

  /* Focus trap al abrir/cerrar via checkbox (PL-1) */
  var releaseMenuTrap = null;

  function closeMenu() {
    checkbox.checked = false;
    checkbox.dispatchEvent(new Event('change'));
  }

  checkbox.addEventListener('change', function() {
    if (checkbox.checked) {
      if (window.ThemeUtils && ThemeUtils.trapFocus) {
        releaseMenuTrap = ThemeUtils.trapFocus(menu, { onEscape: closeMenu });
      }
    } else if (releaseMenuTrap) {
      releaseMenuTrap();
      releaseMenuTrap = null;
    }
  });

  /* Track navigation stack for multi-level back */
  var stack = ['main'];

  function goTo(panelId) {
    var current = panels.querySelector('.mobile-menu__panel.is-active');
    var target = panels.querySelector('[data-panel="' + panelId + '"]');
    if (!current || !target || current === target) return;

    current.classList.remove('is-active');
    current.classList.add('is-hidden-left');
    target.classList.add('is-active');
    target.scrollTop = 0;
    stack.push(panelId);
  }

  function goBack() {
    if (stack.length <= 1) return;

    var current = panels.querySelector('.mobile-menu__panel.is-active');
    stack.pop();
    var parentId = stack[stack.length - 1];
    var parent = panels.querySelector('[data-panel="' + parentId + '"]');
    if (!current || !parent) return;

    current.classList.remove('is-active');
    parent.classList.remove('is-hidden-left');
    parent.classList.add('is-active');
  }

  function resetPanels() {
    panels.querySelectorAll('.mobile-menu__panel').forEach(function(p) {
      p.classList.remove('is-active', 'is-hidden-left');
    });
    var main = panels.querySelector('[data-panel="main"]');
    if (main) main.classList.add('is-active');
    stack = ['main'];
  }

  panels.addEventListener('click', function(e) {
    var gotoBtn = e.target.closest('[data-goto]');
    if (gotoBtn) {
      e.preventDefault();
      goTo(gotoBtn.getAttribute('data-goto'));
      return;
    }
    var backBtn = e.target.closest('[data-back]');
    if (backBtn) {
      e.preventDefault();
      goBack();
    }
  });

  function setMenuState(open) {
    if (open) {
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    } else {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      resetPanels();
    }
  }

  checkbox.addEventListener('change', function() {
    setMenuState(checkbox.checked);
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && checkbox.checked) {
      checkbox.checked = false;
      setMenuState(false);
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-featured"] && !Shopify.designMode) return;
  try {
    (function () {
  /* Delegado en document y no enlazado tarjeta por tarjeta: así funciona con
     las que aparecen después —clones del carrusel, respuestas AJAX, Sections
     API— sin tener que reinicializar nada. Es el mismo patrón de wishlist.js.

     Los textos salen de data-* porque estos bloques no ven Liquid; antes
     estaban en español dentro del JS. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pcard-atc]');
    if (!btn || btn.disabled) return;

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    var original = btn.textContent.trim();
    btn.disabled = true;
    btn.textContent = btn.dataset.addingText || original;

    window.addToCart(variantId, 1)
      .then(function () {
        btn.textContent = btn.dataset.addedText || original;
        setTimeout(function () {
          btn.textContent = original;
          btn.disabled = false;
        }, 2000);
      })
      .catch(function () {
        btn.textContent = original;
        btn.disabled = false;
      });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-carousel"] && !Shopify.designMode) return;
  try {
    class FeaturedProductSlider {
  constructor(container) {
    this.container = container;
    this.viewport = container.querySelector('[data-slider-viewport]');
    this.prevBtn = container.querySelector('[data-arrow-prev]');
    this.nextBtn = container.querySelector('[data-arrow-next]');
    
    if (!this.viewport || !this.prevBtn || !this.nextBtn) return;
    
    this.init();
  }
  
  init() {
    // Scroll Events
    this.nextBtn.addEventListener('click', () => { this.step('next'); this.postpone(); });
    this.prevBtn.addEventListener('click', () => { this.step('prev'); this.postpone(); });
    
    this.viewport.addEventListener('scroll', () => {
      requestAnimationFrame(() => this.updateButtons());
    }, { passive: true });
    
    // Initial and Resize state
    window.addEventListener('resize', () => this.updateButtons());
    this.updateButtons();
    
    // Quick fix for editor and lazy loading
    setTimeout(() => this.updateButtons(), 500);

    this.initAutoplay();
  }

  /* El salto se calculaba con un hueco fijo de 24 px. La separación real la
     define --space-4 en el CSS, así que al cambiarla el carrusel se iba
     desalineando un poco en cada clic. Se lee del propio elemento. */
  get gap() {
    return parseFloat(getComputedStyle(this.viewport.querySelector('.slider-track') || this.viewport).gap) || 16;
  }
  
  step(direction) {
    const slide = this.viewport.querySelector('.slider-slide');
    if (!slide) return;
    
    const moveAmount = slide.offsetWidth + this.gap;
    const max = this.viewport.scrollWidth - this.viewport.clientWidth;
    const destino = direction === 'next'
      ? this.viewport.scrollLeft + moveAmount
      : this.viewport.scrollLeft - moveAmount;

    this.slideTo(Math.max(0, Math.min(destino, max)));
  }

  /* Único punto de desplazamiento, para que la flecha y el avance automático
     compartan el respaldo. Hay contextos donde el navegador ignora el
     desplazamiento suave —pestaña en segundo plano, ventana sin foco— y el
     carrusel se quedaría clavado. Si a los 120 ms no se movió, se asigna
     directo: se pierde la animación, no la función. */
  slideTo(destino) {
    const antes = this.viewport.scrollLeft;
    this.viewport.scrollTo({ left: destino, behavior: 'smooth' });

    setTimeout(() => {
      if (this.viewport.scrollLeft === antes && destino !== antes) {
        this.viewport.scrollLeft = destino;
      }
      this.updateButtons();
    }, 120);
  }

  /* ── Desfile continuo ───────────────────────────────────────────────────
     Las tarjetas pasan sin parar en vez de saltar de una en una. Para que el
     ciclo no dé un tirón al terminar, la lista se duplica: cuando el
     desplazamiento pasa de la mitad se le resta esa mitad, y como a partir de
     ahí se ve el mismo contenido, el salto es invisible.

     Los clones son tarjetas de verdad, no adorno: el botón de comprar va por
     delegación en document y la lista de deseos también, así que funcionan sin
     reinicializar nada.

     Las flechas siguen mandando. Cualquier interacción —ratón encima, foco de
     teclado, dedo, clic en una flecha— detiene el desfile mientras dure, así
     que nunca se mueve debajo de la mano de quien lo está usando.

     Se apaga con `prefers-reduced-motion` y con la pestaña en segundo plano. */
  initAutoplay() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    /* En móvil no: la fila se recorre con el dedo y algo que se mueve solo en
       una pantalla pequeña estorba más que ayuda. */
    if (window.matchMedia('(max-width: 767px)').matches) return;

    this.track = this.viewport.querySelector('.slider-track');
    if (!this.track) return;

    /* Sin desbordamiento no hay nada que desfilar */
    if (this.viewport.scrollWidth <= this.viewport.clientWidth + 4) return;

    this.speed = 30;        // px por segundo
    this.paused = false;
    this.resumeAt = 0;      // marca hasta cuándo sigue detenido
    this.pos = this.viewport.scrollLeft;

    this.cloneSlides();

    const pausar = () => { this.paused = true; };
    const seguir = () => { this.paused = false; };

    this.container.addEventListener('mouseenter', pausar);
    this.container.addEventListener('mouseleave', seguir);
    this.container.addEventListener('focusin',  pausar);
    this.container.addEventListener('focusout', seguir);
    this.container.addEventListener('touchstart', pausar, { passive: true });
    this.container.addEventListener('touchend', seguir, { passive: true });

    /* Desplazamiento a mano —rueda, trackpad, arrastre de la barra—: sin esto
       el bucle reasignaba su propia posición al fotograma siguiente y devolvía
       la fila a donde iba él, peleándose con quien la estaba moviendo. */
    this.viewport.addEventListener('wheel', () => this.postpone(), { passive: true });
    this.viewport.addEventListener('pointerdown', () => this.postpone());

    this.lastFrame = 0;
    this.raf = requestAnimationFrame(t => this.frame(t));
  }

  /* Duplica la fila una vez. `aria-hidden` para que un lector de pantalla no
     lea el catálogo dos veces; los clones siguen siendo clicables con el ratón,
     que es lo que se espera de algo que se ve. */
  cloneSlides() {
    const originales = [...this.track.children];
    this.cicloAncho = this.track.scrollWidth;

    originales.forEach(slide => {
      const copia = slide.cloneNode(true);
      copia.setAttribute('aria-hidden', 'true');
      copia.dataset.clon = 'true';
      this.track.appendChild(copia);
    });
  }

  /* Tras un clic en la flecha, el desfile espera a que termine el
     desplazamiento suave para no pelearse con él. */
  postpone() {
    this.resumeAt = performance.now() + 700;
  }

  frame(ahora) {
    this.raf = requestAnimationFrame(t => this.frame(t));

    if (!this.container.isConnected) { cancelAnimationFrame(this.raf); return; }

    const dt = this.lastFrame ? (ahora - this.lastFrame) / 1000 : 0;
    this.lastFrame = ahora;

    /* Detenido: la posición se resincroniza con la real, para que al reanudar
       se siga desde donde lo dejó la flecha o el dedo, no desde donde iba el
       bucle. */
    if (this.paused || document.hidden || ahora < this.resumeAt) {
      this.pos = this.viewport.scrollLeft;
      return;
    }
    if (dt <= 0 || dt > 0.25) return;   // pestaña que vuelve: no des un tirón

    /* La posición se lleva en coma flotante aparte y se asigna entera. A 60 fps
       el avance por fotograma es de décimas de píxel, y `scrollLeft` redondea:
       sumando sobre él directamente la fracción se pierde en cada fotograma y
       el desfile se queda casi parado. */
    this.pos += this.speed * dt;

    /* Pasada la primera copia, se retrocede un ciclo entero. El contenido a la
       vista es idéntico, así que no se nota. */
    if (this.cicloAncho && this.pos >= this.cicloAncho) {
      this.pos -= this.cicloAncho;
    }

    this.viewport.scrollLeft = this.pos;
  }
  
  updateButtons() {
    const left = this.viewport.scrollLeft;
    const max = this.viewport.scrollWidth - this.viewport.clientWidth;
    
    this.prevBtn.classList.toggle('hidden', left <= 5);
    this.nextBtn.classList.toggle('hidden', left >= max - 5);
  }
}

const initAllProductSliders = () => {
  document.querySelectorAll('[data-slider-container]').forEach(el => {
    if (!el.dataset.sliderInitialized) {
      new FeaturedProductSlider(el);
      el.dataset.sliderInitialized = "true";
    }
  });
};

document.addEventListener('DOMContentLoaded', initAllProductSliders);
document.addEventListener('shopify:section:load', initAllProductSliders);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-bar"] && !Shopify.designMode) return;
  try {
    class PredictiveSearch {
  constructor(wrapper) {
    this.wrapper    = wrapper;
    this.input      = wrapper.querySelector('[data-search-input]');
    this.form       = wrapper.querySelector('[data-search-form]');
    this.clearBtn   = wrapper.querySelector('[data-search-clear]');
    this.loading    = wrapper.querySelector('[data-search-loading]');
    this.results    = wrapper.querySelector('[data-search-results]');
    this.body       = wrapper.querySelector('[data-search-content]');

    const rd = this.results.dataset;
    this.showVendor      = rd.showVendor === 'true';
    this.showCollections = rd.showCollections === 'true';
    this.resultsCount    = parseInt(rd.resultsCount) || 6;
    this.moneyFormat     = this.wrapper.dataset.moneyFormat;

    this.t = {
      soldOut:    this.wrapper.dataset.tSoldOut    || 'Agotado',
      noResults:  this.wrapper.dataset.tNoResults  || 'Sin resultados para "__QUERY__"',
      error:      this.wrapper.dataset.tError      || 'Error al buscar. Intenta de nuevo.',
      categories: this.wrapper.dataset.tCategories || 'Categorías',
      vendors:    this.wrapper.dataset.tVendors    || 'Marcas',
      suggestions: this.wrapper.dataset.tSuggestions || 'Búsquedas sugeridas',
      products:   this.wrapper.dataset.tProducts   || 'Productos',
      recommended: this.wrapper.dataset.tRecommended || 'Creemos que te puede interesar',
      contextualAlternatives: this.wrapper.dataset.tContextualAlternatives || '__CATEGORY__',
      intentLabels: {
        organeta: this.wrapper.dataset.tIntentOrganeta || 'organeta',
        teclado: this.wrapper.dataset.tIntentTeclado || 'teclado',
        grabadora: this.wrapper.dataset.tIntentGrabadora || 'grabadora'
      }
    };

    this.searchTimeout   = null;
    this.currentQuery    = '';
    this.lastCompletedQuery = '';
    this.lastSearchEngine = '';
    this.lastResultCount = null;
    this.abortController = null;
    this.searchRequestId = 0;

    this.setupTypesense();
    this.bindEvents();
  }

  setupTypesense() {
    const enabled    = this.wrapper.dataset.typesenseEnabled === 'true';
    const host       = this.wrapper.dataset.typesenseHost;
    const apiKey     = this.wrapper.dataset.typesenseApiKey;
    const collection = this.wrapper.dataset.typesenseCollection || 'products';

    this.typesenseConfigured = Boolean(enabled && host && apiKey);
    if (!this.typesenseConfigured) { this.useTypesense = false; return; }

    this.tsHost       = host.startsWith('http') ? host : 'https://' + host;
    this.tsApiKey     = apiKey;
    this.tsCollection = collection;
    /* `useTypesense` es el estado de ESTE intento. La configuración se
       conserva para poder reactivarlo cuando venza el circuit breaker. */
    this.useTypesense = !this.tsRecentlyDown();
  }

  /* Señal interna: solo loguea si activas el flag (localStorage.dbg='1').
     Silencioso por defecto — no expone arquitectura a terceros. */
  logEngine(primary, err) {
    try { if (localStorage.getItem('dbg') !== '1') return; } catch (e) { return; }
    if (primary) { console.log('🟢 TS ok'); return; }
    console.warn('🟡 TS down', err ? (err.name + ': ' + err.message) : '(circuit breaker)');
  }

  /* Circuit breaker con TTL — espeja main-search.liquid (ts:down compartido).
     Timestamp; expira a 60s. Valor legacy '1' se trata como expirado. */
  tsRecentlyDown() {
    try {
      var t = parseInt(sessionStorage.getItem('ts:down'), 10);
      if (!t || t < 1000000000000) { sessionStorage.removeItem('ts:down'); return false; }
      if (Date.now() - t < 60000) return true;
      sessionStorage.removeItem('ts:down');
    } catch (e) {}
    return false;
  }

  markTypesenseDown() {
    this.useTypesense = false;
    try { sessionStorage.setItem('ts:down', String(Date.now())); } catch (e) {}
  }

  bindEvents() {
    this.input.addEventListener('input', this.onInput.bind(this));
    if (this.form) {
      this.form.addEventListener('submit', () => {
        const query = this.input.value.trim();
        if (!query || !window.TMSAnalytics) return;
        const resultsCurrent = this.lastCompletedQuery === query;
        TMSAnalytics.capture('tms_search_submitted', {
          search_surface: 'predictive',
          search_engine: resultsCurrent
            ? this.lastSearchEngine
            : (this.typesenseConfigured && !this.tsRecentlyDown() ? 'typesense' : 'predictive'),
          query: query,
          result_count: resultsCurrent ? this.lastResultCount : null,
          results_current: resultsCurrent
        });
      });
    }
    this.input.addEventListener('focus', () => {
      if (this.currentQuery && !this.results.classList.contains('hidden')) return;
      if (this.currentQuery) this.open();
    });
    this.clearBtn.addEventListener('click', this.clear.bind(this));

    document.addEventListener('click', (e) => {
      if (!this.wrapper.contains(e.target)) this.close();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { this.close(); this.input.blur(); }
    });

    /* Reposiciona el panel fixed móvil al rotar/cambiar tamaño si está abierto */
    window.addEventListener('resize', () => {
      if (!this.results.classList.contains('hidden')) this.positionPanel();
    });

    /* Móvil: el teclado tapa media pantalla de resultados. Al empezar a
       scrollear el panel, bajamos el teclado (blur) — el dropdown solo se
       cierra por click afuera o Escape, así que queda abierto y a pantalla
       completa. Patrón estándar (Google, Amazon). */
    this.results.addEventListener('touchmove', () => {
      if (document.activeElement === this.input) this.input.blur();
    }, { passive: true });

    this.results.addEventListener('click', (e) => {
      const link = e.target.closest('a[href]');
      if (!link || !window.TMSAnalytics) return;

      const productLink = link.matches('[data-analytics-product-link]') ? link : null;
      if (productLink) {
        const productLinks = Array.from(this.results.querySelectorAll('[data-analytics-product-link]'));
        TMSAnalytics.capture('tms_search_result_clicked', {
          search_surface: 'predictive',
          search_engine: this.lastSearchEngine || (this.useTypesense ? 'typesense' : 'shopify_predictive'),
          query: this.lastCompletedQuery || this.currentQuery,
          result_count: this.lastResultCount,
          result_position: productLinks.indexOf(productLink) + 1,
          product_handle: productLink.dataset.productHandle,
          product_title: productLink.dataset.productTitle,
          product_vendor: productLink.dataset.productVendor,
          product_type: productLink.dataset.productType,
          result_source: productLink.dataset.searchResultSource,
          destination: productLink.pathname
        });
        return;
      }

      const isViewAll = link.classList.contains('predictive-search__view-all');
      const isVendor = link.closest('.ps-facets') !== null;
      TMSAnalytics.capture('tms_search_suggestion_clicked', {
        search_surface: 'predictive',
        search_engine: this.lastSearchEngine || (this.useTypesense ? 'typesense' : 'shopify_predictive'),
        query: this.lastCompletedQuery || this.currentQuery,
        result_count: this.lastResultCount,
        suggestion_type: isViewAll ? 'view_all' : (isVendor ? 'vendor' : 'collection_or_category'),
        label: link.textContent.trim().replace(/\s+/g, ' ').slice(0, 100),
        destination: link.pathname + link.search
      });
    });
  }

  onInput(e) {
    const q = e.target.value.trim();
    this.clearBtn.hidden = q.length === 0;
    clearTimeout(this.searchTimeout);
    /* Cancela en el momento de escribir, no 280 ms después: una respuesta
       anterior no debe pintar resultados durante el debounce de la nueva. */
    if (q !== this.currentQuery && this.abortController) this.cancelActiveSearch();
    if (q.length < 2) {
      this.cancelActiveSearch();
      this.currentQuery = q;
      this.lastCompletedQuery = '';
      this.lastSearchEngine = '';
      this.lastResultCount = null;
      this.close();
      return;
    }
    this.searchTimeout = setTimeout(() => this.search(q), 280);
  }

  clear() {
    this.input.value = '';
    this.input.focus();
    this.clearBtn.hidden = true;
    this.close();
    this.currentQuery = '';
    this.lastCompletedQuery = '';
    this.lastSearchEngine = '';
    this.lastResultCount = null;
    this.cancelActiveSearch();
  }

  async search(query) {
    if (query === this.currentQuery && (this.abortController || this.lastCompletedQuery === query)) return;
    const totalStartedAt = this.now();
    const requestId = ++this.searchRequestId;
    const previousController = this.abortController;
    const controller = new AbortController();
    if (previousController) previousController.abort();
    this.abortController = controller;
    this.currentQuery = query;
    this.lastCompletedQuery = '';
    this.lastSearchEngine = '';
    this.lastResultCount = null;
    this.showLoading();

    /* El breaker solo evita Typesense durante su TTL. Al vencer, el mismo
       componente vuelve a probarlo sin necesitar recargar la página. */
    const tryTypesense = this.typesenseConfigured && !this.tsRecentlyDown();
    this.useTypesense = tryTypesense;
    let attemptedEngine = tryTypesense ? 'typesense' : 'predictive';
    let typesenseFallback = Boolean(this.typesenseConfigured && !tryTypesense);
    let fallbackReason = typesenseFallback ? 'circuit_breaker' : null;

    try {
      let data;
      const requestStartedAt = this.now();
      if (tryTypesense) {
        try {
          data = await this.fetchTypesense(query, controller.signal);
          if (!this.isCurrentRequest(requestId, controller)) return;
          if (data.found === 0) {
            data.contextual = await this.fetchContextualTypesense(query, controller.signal);
            if (!this.isCurrentRequest(requestId, controller)) return;
          }
          this.logEngine(true);
        } catch (err) {
          /* Escribir otra letra cancela la solicitud anterior. Eso NO es una
             caída de Typesense y nunca debe activar el circuit breaker. */
          if (!this.isCurrentRequest(requestId, controller)) return;
          /* Host caído o lento (timeout): apagar Typesense para la sesión
             y seguir con el buscador nativo sin pagar la espera de nuevo. */
          this.markTypesenseDown();
          this.logEngine(false, err);
          typesenseFallback = true;
          fallbackReason = this.fallbackReason(err);
          attemptedEngine = 'predictive';
          data = await this.fetchPredictive(query, controller.signal);
        }
      } else {
        this.logEngine(false);
        data = await this.fetchPredictive(query, controller.signal);
      }
      if (!this.isCurrentRequest(requestId, controller)) return;
      const requestDuration = this.now() - requestStartedAt;
      const renderStartedAt = this.now();
      this.render(data, query);
      const renderDuration = this.now() - renderStartedAt;
      const totalDuration = this.now() - totalStartedAt;
      this.lastCompletedQuery = query;
      this.lastSearchEngine = data.source;
      this.lastResultCount = data.found;
      if (window.TMSAnalytics) {
        TMSAnalytics.capture('tms_search_performed', {
          search_surface: 'predictive',
          search_engine: data.source,
          query: query,
          result_count: data.found,
          search_request_ms: Math.round(requestDuration),
          search_render_ms: Math.round(renderDuration),
          search_total_ms: Math.round(totalDuration),
          typesense_fallback: typesenseFallback,
          fallback_reason: fallbackReason
        });
        if (data.contextual && data.contextual.products.length) {
          TMSAnalytics.capture('tms_search_contextual_fallback', {
            search_surface: 'predictive',
            search_engine: data.source,
            query: query,
            fallback_intent: data.contextual.intent.key,
            fallback_result_count: data.contextual.products.length
          });
        }
        if (data.found === 0) {
          TMSAnalytics.capture('tms_search_zero_results', {
            search_surface: 'predictive',
            search_engine: data.source,
            query: query,
            result_count: 0,
            typesense_fallback: typesenseFallback,
            fallback_reason: fallbackReason
          });
        }
      }
    } catch (err) {
      if (!this.isCurrentRequest(requestId, controller)) return;
      this.renderError();
      if (window.TMSAnalytics) {
        TMSAnalytics.capture('tms_search_error', {
          search_surface: 'predictive',
          search_engine: attemptedEngine,
          query: query,
          typesense_fallback: typesenseFallback,
          fallback_reason: fallbackReason,
          error: err && err.message ? err.message : 'unknown'
        });
      }
    } finally {
      if (this.abortController === controller) this.abortController = null;
    }
  }

  cancelActiveSearch() {
    this.searchRequestId += 1;
    if (this.abortController) this.abortController.abort();
    this.abortController = null;
  }

  isCurrentRequest(requestId, controller) {
    return requestId === this.searchRequestId
      && this.abortController === controller
      && !controller.signal.aborted;
  }

  fallbackReason(err) {
    if (err && err.name === 'TimeoutError') return 'timeout';
    if (err && /^TS \\d+/.test(err.message || '')) return 'http_error';
    return 'network_error';
  }

  now() {
    return window.performance && typeof window.performance.now === 'function'
      ? window.performance.now()
      : Date.now();
  }

  async fetchTypesense(query, requestSignal) {
    /* Misma curación que la página de resultados: vive en Typesense como
       preset `cur-<término>`. Sin esto, "organeta" mostraba pianos y
       accesorios acá y teclados en la página — dos órdenes para la misma
       consulta. El sort_by de la consulta gana sobre el del preset, así que
       cuando hay preset no se manda. */
    const intentUtils = window.ThemeUtils && ThemeUtils.searchIntent;
    const identifierQuery = intentUtils && intentUtils.isIdentifier(query);
    const preset = (!identifierQuery && window.ThemeUtils && ThemeUtils.curationPreset)
      ? ThemeUtils.curationPreset(query)
      : null;
    const qs = new URLSearchParams({
      q:                  query,
      per_page:           this.resultsCount,
      facet_by:           'product_type,vendor',
      max_facet_values:   8,
      /* Solo disponibles, igual que el fallback nativo
         (unavailable_products=hide). El dropdown muestra 8 resultados: no
         valen para agotados. Y como filtro, no compite con el orden de los
         presets de curación — un sort_by sí lo pisaría. La página de
         resultados sí los muestra, al final y con filtro propio. */
      filter_by: 'available:=true',
    });
    const searchRules = intentUtils
      ? intentUtils.typesenseParams(query, false)
      : { query_by: 'title,sku,vendor,product_type', query_by_weights: '4,3,1,1', num_typos: '0', typo_tokens_threshold: '0', drop_tokens_threshold: '0' };
    Object.keys(searchRules).forEach(key => qs.set(key, searchRules[key]));
    if (preset) qs.set('preset', preset);
    else qs.set('sort_by', '_text_match:desc,available:desc');
    /* Timeout de 4s: si Typesense no responde, fallback al buscador nativo en
       vez de colgar el dropdown. Antes 2.5s — muy corto en móvil, disparaba el
       breaker (y mataba estrellas) por cold-start, no por host caído. */
    const signal = (typeof AbortSignal !== 'undefined' && AbortSignal.any)
      ? AbortSignal.any([requestSignal, AbortSignal.timeout(4000)])
      : requestSignal;
    const searchFetch = intentUtils ? intentUtils.fetchSearch : fetch;
    const res = await searchFetch(
      this.tsHost + '/collections/' + this.tsCollection + '/documents/search?' + qs,
      { headers: { 'X-TYPESENSE-API-KEY': this.tsApiKey }, signal: signal }
    );
    if (!res.ok) throw new Error('TS ' + res.status);
    const d = await res.json();
    const metadata = d.metadata || null;
    const hits = intentUtils && intentUtils.alternateBySuggestedVendors
      ? intentUtils.alternateBySuggestedVendors(d.hits || [], metadata)
      : (d.hits || []);
    return {
      products: hits.map(h => ({
        url:             h.document.url,
        title:           h.document.title,
        image:           h.document.image || null,
        price:           h.document.price,
        compare_at_price: h.document.compare_at_price || null,
        available:       h.document.available,
        vendor:          h.document.vendor,
        product_type:    h.document.product_type,
      })),
      facetCounts: d.facet_counts || [],
      found:       d.found,
      source:      'typesense',
      metadata:    metadata,
    };
  }

  async fetchContextualTypesense(query, requestSignal) {
    const intentUtils = window.ThemeUtils && ThemeUtils.searchIntent;
    if (!intentUtils || intentUtils.isIdentifier(query)) return null;
    const intent = intentUtils.resolveIntent(query);
    if (!intent) return null;

    const signal = (typeof AbortSignal !== 'undefined' && AbortSignal.any)
      ? AbortSignal.any([requestSignal, AbortSignal.timeout(4000)])
      : requestSignal;
    const vendors = intent.alternativeVendors && intent.alternativeVendors.length
      ? intent.alternativeVendors
      : [null];
    const groups = await Promise.all(vendors.map(async vendor => {
      const filters = ['available:=true', intentUtils.filterForIntent(intent)];
      if (vendor) filters.push('vendor:=[`' + String(vendor).replace(/`/g, '\\`') + '`]');
      const qs = new URLSearchParams({
        q: intent.query,
        per_page: this.resultsCount,
        filter_by: filters.filter(Boolean).join('&&')
      });
      const rules = intentUtils.typesenseParams(intent.query, false);
      Object.keys(rules).forEach(key => qs.set(key, rules[key]));
      if (intent.preset) qs.set('preset', intent.preset);
      else qs.set('sort_by', '_text_match:desc,created_at:desc');

      const res = await intentUtils.fetchSearch(
        this.tsHost + '/collections/' + this.tsCollection + '/documents/search?' + qs,
        { headers: { 'X-TYPESENSE-API-KEY': this.tsApiKey }, signal: signal }
      );
      if (!res.ok) return [];
      const d = await res.json();
      return d.hits || [];
    }));
    /* Alternar marcas evita que los primeros ocho espacios queden ocupados
       por una sola. Si una marca tiene menos productos, la otra completa. */
    const hits = [];
    for (let i = 0; hits.length < this.resultsCount && groups.some(group => group[i]); i += 1) {
      groups.forEach(group => {
        if (group[i] && hits.length < this.resultsCount) hits.push(group[i]);
      });
    }
    return {
      intent: intent,
      products: hits.map(h => ({
        url: h.document.url,
        title: h.document.title,
        image: h.document.image || null,
        price: h.document.price,
        compare_at_price: h.document.compare_at_price || null,
        available: h.document.available,
        vendor: h.document.vendor,
        product_type: h.document.product_type
      }))
    };
  }

  async fetchPredictive(query, requestSignal) {
    let url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product`;
    if (this.showCollections) url += ',collection';
    url += `&resources[limit]=20&resources[options][unavailable_products]=hide`;
    url += `&resources[options][fields]=title,product_type,variants.title,vendor,tag`;
    const res = await fetch(url, { signal: requestSignal });
    if (!res.ok) throw new Error('HTTP ' + res.status);
    const d = await res.json();
    /* suggest.json entrega precios en unidades (string); normalizamos a
       centavos para que render() use un solo formato (igual que Typesense) */
    const toCents = (v) => v == null || v === '' ? null : Math.round(parseFloat(v) * 100);
    const products = (d.resources.results.products || []).map(p => ({
      url: p.url, title: p.title, image: p.image,
      price: toCents(p.price),
      /* suggest.json entrega el comparado como compare_at_price_min (no
         compare_at_price). Sin esto el fallback nativo perdía el tachado. */
      compare_at_price: toCents(p.compare_at_price_min != null ? p.compare_at_price_min : p.compare_at_price),
      available: p.available,
      vendor: p.vendor, product_type: p.product_type,
    }));
    return { products, facetCounts: null, found: products.length, source: 'predictive' };
  }

  render(data, query) {
    const products = data.products.slice(0, this.resultsCount);

    if (products.length === 0) {
      /* Sin resultados: las alternativas solo se muestran cuando conocemos la
         familia comercial. Nunca se rellena el espacio con productos al azar. */
      const matches = this.collectionMatches(query, 4);
      const contextual = data.contextual;
      let html = `<p class="ps-empty">${this.t.noResults.replace('__QUERY__', this.escape(query))}</p>`;
      if (matches.length) {
        html += `<div class="ps-pill-row ps-empty-pills">`
          + matches.map(m => `<a href="${m.url}" class="ps-pill ps-pill--suggestion">${this.escape(m.title)}</a>`).join('')
          + `</div>`;
      }
      if (contextual && contextual.products.length) {
        const category = this.t.intentLabels[contextual.intent.key] || contextual.intent.key;
        const productType = contextual.intent.productTypes && contextual.intent.productTypes[0];
        const vendors = contextual.intent.alternativeVendors || [];
        if (productType && vendors.length) {
          html += `<div class="ps-section-label">${this.escape(this.t.suggestions)}</div>`;
          html += '<div class="ps-pill-row ps-empty-pills">'
            + vendors.map(vendor => {
              const label = `${productType} ${vendor}`;
              return `<a href="${this.categorySearchUrl(query, productType, vendor)}" class="ps-pill ps-pill--suggestion">${this.escape(label)}</a>`;
            }).join('')
            + '</div>';
        }
        const label = this.t.contextualAlternatives.replace('__CATEGORY__', category);
        html += `<div class="ps-section-label">${this.escape(label)}</div>`;
        html += '<ul class="predictive-search__list">'
          + contextual.products.map(p => this.productItemHtml(p, '')).join('')
          + '</ul>';
      }
      html += `<a href="/collections/all" class="predictive-search__view-all">
             <span>Ver todo el catálogo</span>
             <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M3 8h10M9 4l4 4-4 4"/></svg>
           </a>`;
      this.body.innerHTML = html;
      this.open();
      return;
    }

    // Facetas (se calculan antes para poder mostrar las sugerencias arriba)
    const rawCategories = data.source === 'typesense'
      ? this.facetsFromTS(data.facetCounts, 'product_type')
      : this.extractFacet(data.products, 'product_type');
    const rawVendors = data.source === 'typesense'
      ? this.facetsFromTS(data.facetCounts, 'vendor')
      : this.extractFacet(data.products, 'vendor');
    const categories = this.sortFacetsByQuery(this.dedupeFacets(rawCategories), query);
    const vendors = this.sortFacetsByQuery(this.dedupeFacets(rawVendors), query);

    // ── 1. Sugeridas: categorías encontradas primero. Conservan la consulta y,
    //       cuando el término es una marca exacta, también fijan ese vendor. ──
    const queryKey = this.normalizeKey(query);
    const exactVendor = vendors.find(v => this.normalizeKey(v.value) === queryKey);
    const collMatches = this.collectionMatches(query, 4)
      .filter(c => c.key !== queryKey); // "Fender" al buscar Fender es redundante
    const catPills = [];
    const metadataSuggestions = data.source === 'typesense'
      && window.ThemeUtils && ThemeUtils.searchIntent
      && ThemeUtils.searchIntent.suggestedSearches
      ? ThemeUtils.searchIntent.suggestedSearches(data.metadata)
      : [];
    metadataSuggestions.forEach(suggestion => {
      if (catPills.length >= 4) return;
      catPills.push({
        label: suggestion.label,
        url: this.categorySearchUrl(query, suggestion.product_type, suggestion.vendor)
      });
    });
    categories.forEach(c => {
      if (catPills.length >= 4) return;
      if (catPills.some(p => this.normalizeKey(p.label) === this.normalizeKey(c.value))) return;
      catPills.push({
        label: c.value,
        url: this.categorySearchUrl(query, c.value, exactVendor && exactVendor.value)
      });
    });
    collMatches.forEach(c => {
      if (catPills.length >= 6) return;
      if (catPills.some(p => this.normalizeKey(p.label) === c.key)) return;
      catPills.push({ label: c.title, url: c.url });
    });

    /* Layout con "panel dividido" en desktop: productos a la izquierda, rail
       (categorías + marcas) a la derecha para aprovechar el ancho. El orden del
       DOM (categorías → productos → marcas) preserva el apilado en móvil; en
       desktop las grid-areas recolocan. Solo hay rail si hay contenido para él. */
    const hasRail = catPills.length > 0 || vendors.length > 0;
    let html = `<div class="ps-layout${hasRail ? ' ps-layout--split' : ''}">`;

    // ── 1. Categorías (rail derecho en desktop / arriba en móvil) ──
    if (catPills.length > 0) {
      html += `<div class="ps-suggestions">
        <div class="ps-section-label">${this.t.suggestions}</div>
        <div class="ps-pill-row">`;
      catPills.forEach(p => {
        html += `<a href="${p.url}" class="ps-pill ps-pill--suggestion">${this.escape(p.label)}</a>`;
      });
      html += '</div></div>';
    }

    // ── 2. Productos (columna izquierda) ──
    html += '<div class="ps-products">';
    html += `<div class="ps-section-label">${this.t.products}</div>`;
    html += '<ul class="predictive-search__list">';
    products.forEach(p => { html += this.productItemHtml(p, query); });
    html += '</ul>';
    html += '</div>';

    // ── 3. Marcas (rail derecho en desktop / abajo en móvil) ──
    if (vendors.length > 0) {
      html += '<div class="ps-facets">';
      html += `<div class="ps-facet-row">
        <span class="ps-facet-label">${this.t.vendors}</span>`;
      vendors.slice(0, 5).forEach(v => {
        /* Mantiene el término: "estuches" + marca → estuches DE esa marca
           (no todos los productos de la marca). */
        const url = `/search?q=${encodeURIComponent(query)}&type=product&vendor=${encodeURIComponent(v.value)}`;
        html += `<a href="${url}" class="ps-pill">${this.escape(v.value)} <span>${v.count}</span></a>`;
      });
      html += '</div></div>';
    }

    html += '</div>'; // .ps-layout

    // ── "Ver todos" (ancho completo, bajo el layout) ──
    /* Arrastra `available=true` para que el conteo del badge describa lo que
       el cliente va a ver: el dropdown solo cuenta disponibles, y sin el
       parámetro la página abriría con bastantes más. En la página el filtro
       sale como chip y se puede quitar. */
    const viewAllUrl = `/search?q=${encodeURIComponent(query)}&type=product&available=true`;
    const countBadge = data.found > this.resultsCount
      ? `<span class="ps-view-all__count">${data.found.toLocaleString('es-CO')}</span>` : '';
    html += `<a href="${viewAllUrl}" class="predictive-search__view-all">
      <span>Ver todos los resultados para "<strong>${this.escape(query)}</strong>"</span>
      <span class="ps-view-all__right">
        ${countBadge}
        <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M3 8h10M9 4l4 4-4 4"/></svg>
      </span>
    </a>`;

    this.body.innerHTML = html;
    this.open();
  }

  facetsFromTS(facetCounts, field) {
    if (!facetCounts) return [];
    const facet = facetCounts.find(f => f.field_name === field);
    if (!facet) return [];
    return facet.counts.map(c => ({ value: c.value, count: c.count }));
  }

  /* Une facetas que solo difieren en mayúsculas/acentos/espacios
     ("Guitarra Eléctrica" + "guitarra electrica" → una sola, sumando counts).
     Display = la grafía con más resultados (la más canónica en la data). */
  /* Normalización compartida para comparar consultas, marcas, tipos y títulos
     de colección sin que acentos, mayúsculas o plurales creen duplicados. */
  normalizeKey(s) {
    return s
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .split(/\s+/)
      .map(w => w.replace(/s$/, ''))
      .join(' ')
      .trim();
  }

  collectionsData() {
    if (window.__collectionsData) return window.__collectionsData;
    const map = {};
    const list = [];
    const el = document.querySelector('[data-collections-map]');
    if (el) {
      try {
        const raw = JSON.parse(el.textContent);
        Object.keys(raw).forEach(k => {
          const nk = this.normalizeKey(k);
          map[nk] = raw[k];
          list.push({ key: nk, title: k, url: raw[k] });
        });
      } catch (e) { /* mapa malformado → chips caen a búsqueda */ }
    }
    return (window.__collectionsData = { map, list });
  }

  categorySearchUrl(query, productType, vendor) {
    const params = new URLSearchParams({
      q: query,
      type: 'product',
      product_type: productType,
      available: 'true'
    });
    if (vendor) params.append('vendor', vendor);
    return `/search?${params.toString()}`;
  }

  /* Colecciones cuyo título CONTIENE el término (chips que llevan a la
     colección real, no a resultados). Prioriza las que empiezan por el término. */
  collectionMatches(query, limit) {
    const q = this.normalizeKey(query);
    if (!q) return [];
    const starts = [];
    const contains = [];
    this.collectionsData().list.forEach(c => {
      const i = c.key.indexOf(q);
      if (i === 0) starts.push(c);
      else if (i > 0) contains.push(c);
    });
    return starts.concat(contains).slice(0, limit || 4);
  }

  /* Un <li> de producto (reusado por resultados y por el estado sin-resultados) */
  productItemHtml(p, query) {
    const img = p.image
      ? `<img src="${p.image}" alt="" class="ps-image" loading="lazy" width="64" height="64">`
      : `<div class="ps-image ps-image--empty"></div>`;
    const metaParts = [];
    if (this.showVendor && p.vendor) metaParts.push(`<strong>${this.escape(p.vendor)}</strong>`);
    if (p.product_type) metaParts.push(this.escape(p.product_type));
    const meta = metaParts.length ? `<p class="ps-meta">${metaParts.join('<span class="ps-meta-dot">·</span>')}</p>` : '';
    const hasCompare = p.compare_at_price && p.compare_at_price > p.price;
    const title = query ? ThemeUtils.highlightMatch(p.title, query) : this.escape(p.title);
    const priceHtml = `
      <p class="ps-price${hasCompare ? ' ps-price--sale' : ''}">
        ${hasCompare ? `<s class="ps-compare">${ThemeUtils.formatMoney(p.compare_at_price, this.moneyFormat)}</s>` : ''}
        ${p.price != null ? ThemeUtils.formatMoney(p.price, this.moneyFormat) : ''}
        ${!p.available ? `<span class="ps-badge">${this.t.soldOut}</span>` : ''}
      </p>`;
    return `
      <li>
        <a
          href="${p.url}"
          class="predictive-search__item"
          data-analytics-product-link
          data-product-handle="${this.escape((p.url || '').split('?')[0].split('/').pop())}"
          data-product-title="${this.escape(p.title)}"
          data-product-vendor="${this.escape(p.vendor || '')}"
          data-product-type="${this.escape(p.product_type || '')}"
          data-search-result-source="${query ? 'search' : 'recommendation'}"
        >
          ${img}
          <div class="ps-info">
            <p class="ps-title">${title}</p>
            ${meta}
            ${priceHtml}
          </div>
          <svg class="ps-item-arrow" width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="M6 4l4 4-4 4"/></svg>
        </a>
      </li>`;
  }

  dedupeFacets(facets) {
    const map = new Map();
    facets.forEach(f => {
      const key = f.value
        .toLowerCase()
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '') // quita acentos
        .replace(/\s+/g, ' ').trim();
      const existing = map.get(key);
      if (existing) {
        existing.count += f.count;
        if (f.count > existing._winnerCount) { existing.value = f.value; existing._winnerCount = f.count; }
      } else {
        map.set(key, { value: f.value, count: f.count, _winnerCount: f.count });
      }
    });
    return Array.from(map.values()).map(({ value, count }) => ({ value, count }));
  }

  sortFacetsByQuery(facets, query) {
    const q = query.toLowerCase();
    return facets.slice().sort((a, b) => {
      const aStarts = a.value.toLowerCase().startsWith(q);
      const bStarts = b.value.toLowerCase().startsWith(q);
      if (aStarts && !bStarts) return -1;
      if (!aStarts && bStarts) return 1;
      return b.count - a.count; // empate → más resultados primero
    });
  }

  extractFacet(products, field) {
    const map = new Map();
    products.forEach(p => {
      if (!p[field]) return;
      map.set(p[field], (map.get(p[field]) || 0) + 1);
    });
    return Array.from(map.entries())
      .map(([value, count]) => ({ value, count }))
      .sort((a, b) => b.count - a.count);
  }

  showLoading() {
    this.loading.classList.remove('hidden');
    this.body.innerHTML = `<div class="ps-skeleton">
      ${Array(3).fill(0).map(() => `
        <div class="ps-skeleton-item">
          <div class="ps-skeleton-img"></div>
          <div class="ps-skeleton-lines">
            <div class="ps-skeleton-line"></div>
            <div class="ps-skeleton-line"></div>
            <div class="ps-skeleton-line"></div>
          </div>
        </div>`).join('')}
    </div>`;
    this.open();
  }

  renderError() {
    this.loading.classList.add('hidden');
    this.body.innerHTML = `<p class="ps-empty">${this.t.error}</p>`;
    this.open();
  }

  open() {
    this.loading.classList.add('hidden');
    this.results.classList.remove('hidden');
    this.input.setAttribute('aria-expanded', 'true');
    this.positionPanel();
  }

  /* En móvil el panel es fixed fullscreen: lo anclamos justo bajo el input
     (su borde inferior) para que cubra el resto de la pantalla. En desktop
     limpiamos el top inline y vuelve al posicionamiento absoluto del CSS. */
  positionPanel() {
    if (window.innerWidth <= 1023) {
      const rect = this.wrapper.getBoundingClientRect();
      this.results.style.top = Math.round(rect.bottom) + 'px';
    } else {
      this.results.style.top = '';
    }
  }

  close() {
    this.results.classList.add('hidden');
    this.input.setAttribute('aria-expanded', 'false');
  }

  escape(str) {
    return String(str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-search-wrapper]').forEach(el => new PredictiveSearch(el));
});

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('[data-search-wrapper]').forEach(el => new PredictiveSearch(el));
  });
}
  } catch(e) { console.error(e); }
})();

})();
